import React from "react";
import styled from "styled-components";
import Icon from "./Icon";

const Container = styled.div`
    position: fixed;
    left: 0;
    width: 23%;
    height: 100%;
`;

export class Comments extends React.Component {
    render() {
        return (
            <Container>
                <Icon width="20px" height="20px" top={160} />
            </Container>
        );
    }
}
